import { createStyles, makeStyles } from '@material-ui/styles';
import anime from 'animejs';
import { FC, useRef } from 'react';
import * as React from 'react';
import DocumentMeta from 'react-document-meta';
import * as ReactGA from 'react-ga';
import { useApi } from 'src/@context/Api';
import stylesheet from 'src/constants/stylesheet';
import useReactRouter from 'use-react-router';
import Artists from './Artists';
import Exhibitions from './Exhibitions';
import Fairs from './Fairs';
import Footer from './Footer';
import PanelPage from './PanelPage';

const useStyles = makeStyles(() =>
  createStyles({
    loadingContainer: {
      transition: 'opacity 0.2s',
      pointerEvents: 'none',
      top: '50vh',
      left: '50vw',
      position: 'fixed',
      transform: 'translate(-50%,-50%)'
    },
    loadingText: {
      ...stylesheet.BoldText
    },

  }));

export type PagesProps = {};

type Props = PagesProps;

const Pages: FC<Props> = () => {
  const cls = useStyles();
  const { location, location: { pathname } } = useReactRouter();
  const url = useRef(location.pathname);
  const { get, app } = useApi();
  const [page, setPage] = React.useState<IPageDto>();
  const [newPage, setNewPage] = React.useState<IPageDto>();

  const [animating, setAnimating] = React.useState(false);
  const [fetching, setFetching] = React.useState(false);
  const [showing, setShowing] = React.useState(false);

  const body = document.body;
  const container = useRef<HTMLDivElement>(null);

  const scrollContainer = document.getElementById('scrollContainer');

  React.useEffect(() => {
    if (!scrollContainer) { return };

    if (scrollContainer.scrollTop > 0) {
      scrollContainer.scrollTop = 0
    }

  }, [page]);

  const fetchPage = async () => {
    const endpoint = location.pathname;
    url.current = endpoint;
    setFetching(true);
    const pageDto = await get(endpoint);

    if (endpoint === url.current) {
      if (page) {
        setNewPage(pageDto);
      } else {
        setPage(pageDto);
      }
      setFetching(false);
    }
  }

  const duration = 300;

  const show = (flag: boolean) => {
    if (!container.current) { return; }
    setShowing(flag);
    setAnimating(true);
    anime({
      targets: container.current,
      opacity: flag ? 1 : 0,
      marginTop: flag ? 0 : '10vh',
      easing: 'linear',
      duration
    }).finished.then(() => {
      setAnimating(false);
    });
  }

  React.useEffect(() => {
    if (body && page) {
      body.setAttribute("data-type", page.type);
    }
  }, [page]);

  React.useEffect(() => {
    show(false);
    fetchPage();
  }, [pathname]);

  React.useEffect(() => {
    if (showing) { return; }
    if (animating) { return; }
    if (fetching) { return; }
    if (newPage) {
      setPage(newPage);
      setNewPage(undefined);
    }
    show(true);
  }, [fetching, animating]);

  React.useEffect(() => {
    if (!body || body.classList.contains('hide-intro')) { return };

    setTimeout(() => body.classList.add("hide-intro"), 3000);
  }, []);

  React.useEffect(
    () => {
      if (!app || !app.Config) { return; }
      const config = app.Config;

      if (!config.GoogleAnalyticsCode) { return; }

      ReactGA.initialize(`${config.GoogleAnalyticsCode}`);
      ReactGA.pageview(window.location.pathname);
    }, [page, app]);

  return (
    <>
      {page && app &&
        <DocumentMeta
          title={page.PageTitle || app.Config.WebsiteTitle || ''}
          description={page.Description || app.Config.Description || ''}
        />
      }
      <div
        className={cls.loadingContainer}
        style={{ opacity: (fetching && !animating && !showing && 1) || 0, }}
      >
        <div
          className={cls.loadingText}
        >
          LOADING
        </div>
      </div>

      <div ref={container}>
        {page && page.type === "Exhibitions" &&
          <Exhibitions
            {...page as ExhibitionsDto}
          />
        }
        {page && page.type === "Fairs" &&
          <Fairs
            {...page as FairsDto}
          />
        }
        {page && page.type === "Exhibition" &&
          <PanelPage
            {...page as ExhibitionDto}
          />
        }
        {page && page.type === "Fair" &&
          <PanelPage
            {...page as FairDto}
          />
        }
        {page && page.type === "Informations" &&
          <PanelPage
            {...page as InformationsDto}
          />
        }
        {page && page.type === "Artists" &&
          <Artists
            {...page as ArtistsDto}
          />
        }
        {page && page.type === "LegalInformation" &&
          <PanelPage
            {...page as LegalInformationDto}
          />
        }
        {page && page.type === "Artist" &&
          <PanelPage
            {...page as ArtistDto}
          />
        }
        {page &&
          <Footer pageType={page.type} />
        }
      </div>
    </>
  );
};

export default Pages;



// WEBPACK FOOTER //
// ./src/Components/Pages.tsx